import { l10nEnService } from '@uplift/services';
import { AssessmentKeys } from '@uplift/types';

export const getActionItemAssessmentText = (assessment: AssessmentKeys, score: number, l10n: typeof l10nEnService) => {
  switch (assessment) {
    case 'gad7':
      return getGAD7ActionItemText(score, l10n);
    case 'phq9':
      return getPHQ9ActionItemText(score, l10n);
  }
};

const getGAD7ActionItemText = (score: number, l10n: typeof l10nEnService) => {
  if (score >= 13 && score <= 14) {
    return l10n.dashboard.actionItems.seePsych.assessments.gad7.moderate;
  } else if (score >= 15) {
    return l10n.dashboard.actionItems.seePsych.assessments.gad7.severe;
  }
};

const getPHQ9ActionItemText = (score: number, l10n: typeof l10nEnService) => {
  if (score >= 15 && score <= 19) {
    return l10n.dashboard.actionItems.seePsych.assessments.phq9.moderate;
  } else if (score >= 20) {
    return l10n.dashboard.actionItems.seePsych.assessments.phq9.severe;
  }
};
